"use strict";

var defaultLinePrice = 5;
var defaultLinePriceSmallQuantities = 2.5;

module.exports = function (accumulator, order, product, component, options) {
  if (parseInt(component.quantity, 10) <= 5) {
    return (parseInt(accumulator, 10) || 0) + (options.linePriceSmallQuantities || defaultLinePriceSmallQuantities);
  }

  return (parseInt(accumulator, 10) || 0) + (options.linePrice || defaultLinePrice);
};